import {
  PropertyFiltersSidebar,
  PropertyFiltersSidebarProps,
} from "./PropertyFiltersSidebar";
import {
  PropertyDetailsSidebar,
  PropertyDetailsSidebarProps,
} from "./PropertyDetailsSidebar";
import {
  PropertiesListSidebar,
  PropertiesListSidebarProps,
} from "../../SearchListings/PropertiesListSidebar";
import LayeredPanels from "../../common/page/LayeredPanels";

export enum EnumSidebars {
  PropertyFilters = "propertyFilters",
  PropertyDetails = "propertyDetails",
  PropertiesList = "propertiesList",
}

export const Sidebar = ({
  stack,
  PropertyFiltersSidebarProps,
  PropertyDetailsSidebarProps,
  PropertiesListSidebarProps,
}: {
  stack: EnumSidebars[];
  PropertyFiltersSidebarProps: PropertyFiltersSidebarProps;
  PropertyDetailsSidebarProps: PropertyDetailsSidebarProps;
  PropertiesListSidebarProps: PropertiesListSidebarProps;
}) => (
  <LayeredPanels
    stack={stack}
    panels={[
      {
        id: EnumSidebars.PropertiesList,
        content: <PropertiesListSidebar {...PropertiesListSidebarProps} />,
      },
      {
        id: EnumSidebars.PropertyDetails,
        content: <PropertyDetailsSidebar {...PropertyDetailsSidebarProps} />,
      },
      {
        id: EnumSidebars.PropertyFilters,
        content: <PropertyFiltersSidebar {...PropertyFiltersSidebarProps} />,
      },
    ]}
  />
);
